import React from "react";
import PropTypes from "prop-types";
import { AutocompleteField, Form as FormikForm, InputField, TextareaField } from "components/common_components/Formik";
import Grid from "@material-ui/core/Grid";
import * as Yup from "yup";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";

function Form({ data, mode, resources, ...rest }) {
    const validationSchema = Yup.object({
        id: Yup.string().required("Required field").max(50, "Max length is 50 characters"),
        category: Yup.string().required("Required field").max(100, "Max length is 100 characters"),
        description: Yup.string().notRequired().max(500, "Max length is 500 characters"),
        parentCategory: Yup.object().nullable().notRequired(),
    });

    return (
        <FormikForm initialValues={data} validationSchema={validationSchema} {...rest}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <FormControl component="fieldset">
                        <FormGroup row>
                            <InputField
                                disabled={mode === "update"}
                                fieldName="id"
                                label="Identifier *"
                                uppercase
                                fullWidth={false}
                                maxLength={50}
                            />
                            <InputField fieldName="category" label="Category *" maxLength={100} />
                            <TextareaField fieldName="description" label="Description" maxLength={500} />
                            <AutocompleteField fieldName="parentCategory" label="Parent Category" options={resources?.categories} labelKey="category" valueKey="id" />
                        </FormGroup>
                    </FormControl>
                </Grid>
            </Grid>
        </FormikForm>
    );
}

Form.propTypes = {
    data: PropTypes.shape({
        id: PropTypes.string,
        category: PropTypes.string,
        description: PropTypes.string,
        parentCategory: PropTypes.shape({
            id: PropTypes.string,
            category: PropTypes.string,
        }),
    }),
    mode: PropTypes.oneOf(["add", "update"]).isRequired,
    resources: PropTypes.shape({
        categories: PropTypes.array,
    }),
};

Form.defaultProps = {
    data: {
        id: "",
        category: "",
        description: "",
        parentCategory: null,
    },
    resources: {
        categories: [],
    },
};

export default Form;
